import React from 'react';
import { GatewayTransactionCsobRefreshErrorEnum } from '../../../../graphql-operations';

const REFRESH_ERROR: Record<GatewayTransactionCsobRefreshErrorEnum, string> = {
  TX_NOT_FOUND: 'Transakce v bance neexistuje',
  PAYMENT_ALREADY_EXISTS: 'Nelze zaplatit již zaplacený oddíl / známku',
  DRY_RUN_PAYMENT_CHANGED: 'Aktualizace by přidala / odebrala platbu',
  UNKNOWN: 'Neznámá chyba'
};

interface TransactionRefreshErrorProps extends React.HTMLAttributes<HTMLSpanElement> {
  error: GatewayTransactionCsobRefreshErrorEnum;
}

export default function TransactionRefreshError({ error, ...props }: TransactionRefreshErrorProps) {
  const errorLabel = REFRESH_ERROR[error];

  return (
    <span {...props} className={`text-danger ${props.className || ''}`}>
      {errorLabel}
    </span>
  );
}
